module.exports = __webpack_public_path__ + "media/new/red-96-c3a8b458.png";